import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PaymentsIcon from "@mui/icons-material/Payments";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { useAuth } from "@/auth/AuthContext";

export default function ForDoctorsPage() {
  const { registerAsDoctor, login, isAuthenticated, isDoctor } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={7}>
          <Typography variant="overline" color="primary.dark" fontWeight={700}>
            For doctors
          </Typography>
          <Typography variant="h3" sx={{ mt: 1, mb: 2 }}>
            Run your online practice with confidence.
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3, fontSize: 18 }}>
            Share your availability, consult patients on video, and let
            ChikitsaLink handle verification, payments, reminders and
            receipts.
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Signing up as a doctor is a two-step process. First create your
            basic profile, then submit your medical council registration
            details. Our admin team verifies within 2 business days and
            patients only see you after approval.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            {!isAuthenticated ? (
              <>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => registerAsDoctor("/doctor/onboarding")}
                >
                  Join as a doctor
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => login("/doctor/dashboard")}
                >
                  Existing doctor — log in
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                size="large"
                href={isDoctor ? "/doctor/dashboard" : "/patient/dashboard"}
              >
                Go to dashboard
              </Button>
            )}
          </Stack>
        </Grid>
        <Grid item xs={12} md={5}>
          <Paper variant="outlined" sx={{ p: 3 }}>
            <Grid container spacing={2}>
              {features.map((f) => (
                <Grid item xs={12} key={f.title}>
                  <Stack direction="row" spacing={2}>
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: 2,
                        bgcolor: "primary.main",
                        color: "#fff",
                        display: "grid",
                        placeItems: "center",
                        flex: "0 0 auto",
                      }}
                    >
                      {f.icon}
                    </Box>
                    <Box>
                      <Typography fontWeight={700}>{f.title}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {f.text}
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

const features = [
  {
    icon: <VerifiedUserIcon />,
    title: "Verification, done right",
    text: "Submit your registration and credentials once. Admin reviews and you're live.",
  },
  {
    icon: <ScheduleIcon />,
    title: "Flexible availability",
    text: "Publish weekly windows. Slots are generated automatically for patients.",
  },
  {
    icon: <PaymentsIcon />,
    title: "Secure fee collection",
    text: "Consult fees collected securely. Receipts and refunds handled for you.",
  },
  {
    icon: <NotificationsActiveIcon />,
    title: "Smart reminders",
    text: "Email and push notifications for booking, cancellation and confirmation.",
  },
];
